/**
* Include your custom JavaScript here.
*
* We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
* changes on product page, you can attach a listener to the document:
*
* document.addEventListener('variant:changed', function(event) {
*   var variant = event.detail.variant; // Gives you access to the whole variant details
* });
*
* You can also add a listener whenever a product is added to the cart:
*
* document.addEventListener('product:added', function(event) {
*   var variant = event.detail.variant; // Get the variant that was added
*   var quantity = event.detail.quantity; // Get the quantity that was added
* });
*
* If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
* "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
*
* document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
*   bubbles: true
* }));
*/

let tickerSpeed = 0.5;
let isPaused = false;

const slideshowEls = [
  document.querySelector('.featured_collection_slider'),
  document.querySelector('.image_slider_collection'),
  document.querySelector('.image_slider_collection_new')
];

// Create Flickity instances for all sliders
let flickities = slideshowEls.map(el => {
  if (!el) return null;
  let flkty = new Flickity(el, {
    autoPlay: false,
    prevNextButtons: true,
    pageDots: false,
    draggable: true,
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25,
    arrowShape: 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z'
  });
  flkty.x = 0;
  return flkty;
});

// --- Auto update loop for ALL sliders
const update = () => {
  if (isPaused) return;

  flickities.forEach(flkty => {
    if (flkty && flkty.slides) {
      flkty.x = (flkty.x - tickerSpeed) % flkty.slideableWidth;
      flkty.selectedIndex = flkty.dragEndRestingSelect();
      flkty.updateSelectedSlide();
      flkty.settle(flkty.x);
    }
  });

  window.requestAnimationFrame(update);
};

// --- Pause / play events
slideshowEls.forEach(el => {
  if (!el) return;
  el.addEventListener('mouseenter', () => isPaused = true);
  el.addEventListener('focusin', () => isPaused = true);
  el.addEventListener('mouseleave', () => { isPaused = false; update(); });
  el.addEventListener('focusout', () => { isPaused = false; update(); });
});

// --- Pause while dragging
flickities.forEach(flkty => {
  if (!flkty) return;
  flkty.on('dragStart', () => { isPaused = true; });
});

update();

